import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle({ fixed = false, style: outerStyle }) {
  const { isDark, toggleTheme } = useTheme();

  const btnStyle = {
    background: "rgba(var(--c-on-bg),0.06)",
    border: "1px solid rgba(var(--c-on-bg),0.1)",
    borderRadius: 10,
    padding: "7px 11px",
    cursor: "pointer",
    transition: "all 0.18s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...outerStyle,
  };

  const wrap = fixed ? {
    position: "fixed",
    top: "calc(20px + env(safe-area-inset-top, 0px))",
    insetInlineEnd: "calc(24px + 80px + 12px)", // sit left of language toggle
    zIndex: 150,
  } : undefined;

  const btn = (
    <button
      type="button"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      onClick={toggleTheme}
      style={btnStyle}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(201,168,76,0.1)";
        e.currentTarget.style.borderColor = "rgba(201,168,76,0.3)";
        const icon = e.currentTarget.querySelector("svg");
        if (icon) icon.style.stroke = "#c9a84c";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(var(--c-on-bg),0.06)";
        e.currentTarget.style.borderColor = "rgba(var(--c-on-bg),0.1)";
        const icon = e.currentTarget.querySelector("svg");
        if (icon) icon.style.stroke = "rgba(var(--c-on-bg),0.6)";
      }}
    >
      {isDark ? (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(var(--c-on-bg),0.6)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transition:"stroke 0.18s" }}>
          <circle cx="12" cy="12" r="4"/>
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>
        </svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(var(--c-on-bg),0.6)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transition:"stroke 0.18s" }}>
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
        </svg>
      )}
    </button>
  );

  if (fixed) return <div style={wrap}>{btn}</div>;
  return btn;
}
